import script from "./ProfilePasswordReset.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePasswordReset.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePasswordReset.vue?vue&type=style&index=0&id=2fe4af76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe4af76"]])

export default __exports__